import { render } from "./CardHorizontalSimple.vue?vue&type=template&id=5c6a2107&scoped=true"
import script from "./CardHorizontalSimple.vue?vue&type=script&lang=js"
export * from "./CardHorizontalSimple.vue?vue&type=script&lang=js"

import "./CardHorizontalSimple.vue?vue&type=style&index=0&id=5c6a2107&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6a2107"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
